"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _colors = require("HubStyleTokens/colors");

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _ItemConfigsSelectors = require("../../selectors/ItemConfigsSelectors");

var _itemConfigUtils = require("../../utils/itemConfigUtils");

var Terms = _interopRequireWildcard(require("self-service-api/constants/Terms"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: inline;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: center !important;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FullPriceContainerBase = _styledComponents.default.div.withConfig({
  displayName: "HighlightedMerchPriceDisplay__FullPriceContainerBase",
  componentId: "sainix-0"
})(["color:", ";font-size:20px;font-weight:500;line-height:initial;padding:1px 0 2px 8px;"], _colors.PANTERA);

var FullPriceContainerBlock = (0, _styledComponents.default)(FullPriceContainerBase).withConfig({
  displayName: "HighlightedMerchPriceDisplay__FullPriceContainerBlock",
  componentId: "sainix-1"
})(["display:block;"]);

var PriceContainer = _styledComponents.default.div.withConfig({
  displayName: "HighlightedMerchPriceDisplay__PriceContainer",
  componentId: "sainix-2"
})(["line-height:initial;"]);

var DiscountedPriceContainer = _styledComponents.default.div.withConfig({
  displayName: "HighlightedMerchPriceDisplay__DiscountedPriceContainer",
  componentId: "sainix-3"
})(["color:", ";font-size:20px;font-weight:500;padding:1px 0 2px 8px;line-height:initial;display:inline-block;"], _colors.OZ);

var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "HighlightedMerchPriceDisplay__CrossedOutPrice",
  componentId: "sainix-4"
})(["text-decoration:line-through;"]);
var CrossedOutSubtextPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "HighlightedMerchPriceDisplay__CrossedOutSubtextPrice",
  componentId: "sainix-5"
})(["text-decoration:line-through;"]);

var PriceSection = _styledComponents.default.div.withConfig({
  displayName: "HighlightedMerchPriceDisplay__PriceSection",
  componentId: "sainix-6"
})(["text-align:", ";", ";"], function (_ref) {
  var textAlign = _ref.textAlign;
  return textAlign;
}, _responsiveBreakpoints.default.tablet(_templateObject()));

var MicroCopy = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "HighlightedMerchPriceDisplay__MicroCopy",
  componentId: "sainix-7"
})(["display:block;", ""], _responsiveBreakpoints.default.tablet(_templateObject2()));

var Bold = _styledComponents.default.span.withConfig({
  displayName: "HighlightedMerchPriceDisplay__Bold",
  componentId: "sainix-8"
})(["color:", ";font-weight:600;"], _colors.PANTERA);

var StyledAsterisk = (0, _styledComponents.default)(MicroCopy).withConfig({
  displayName: "HighlightedMerchPriceDisplay__StyledAsterisk",
  componentId: "sainix-9"
})(["display:inline-block;"]);

var HighlightedMerchPriceDisplay = function HighlightedMerchPriceDisplay(_ref2) {
  var merchandiseId = _ref2.merchandiseId,
      activeCurrencyCode = _ref2.activeCurrencyCode,
      pricingInfo = _ref2.pricingInfo,
      showDiscountedPricing = _ref2.showDiscountedPricing,
      _ref2$showPriceAsteri = _ref2.showPriceAsterisk,
      showPriceAsterisk = _ref2$showPriceAsteri === void 0 ? false : _ref2$showPriceAsteri,
      availableTerms = _ref2.availableTerms,
      activeTerm = _ref2.activeTerm,
      _ref2$textAlign = _ref2.textAlign,
      textAlign = _ref2$textAlign === void 0 ? 'right' : _ref2$textAlign;
  var _pricingInfo$monthly = pricingInfo.monthly,
      monthlyFullPrice = _pricingInfo$monthly.fullPrice,
      monthlyCalculatedPrice = _pricingInfo$monthly.calculatedPrice,
      _pricingInfo$annually = pricingInfo.annually,
      annualFullPrice = _pricingInfo$annually.fullPrice,
      annualCalculatedPrice = _pricingInfo$annually.calculatedPrice;
  var annualOnly = !availableTerms.monthly;
  var discountedKey = activeTerm === Terms.MONTHLY ? 'discountedPricingPerMonthBilledMonthly_jsx' : 'discountedPricingPerYearAtCost_jsx';
  var normalKey = annualOnly ? 'pricingPerYearAtCost_jsx' : 'pricingPerMonthBilledMonthly_jsx';
  return _react.default.createElement(PriceSection, {
    textAlign: textAlign
  }, showDiscountedPricing ? _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage." + discountedKey,
    options: {
      currencyCode: activeCurrencyCode,
      fullPrice: monthlyFullPrice,
      discountedPrice: monthlyCalculatedPrice,
      merchandiseId: merchandiseId,
      annualFullPrice: annualFullPrice,
      annualDiscountedPrice: annualCalculatedPrice
    },
    elements: {
      MicroCopy: MicroCopy,
      DiscountedPriceContainer: DiscountedPriceContainer,
      CrossedOutPrice: CrossedOutPrice,
      CrossedOutSubtextPrice: CrossedOutSubtextPrice,
      PriceDisplay: _PriceDisplay.default,
      Bold: Bold,
      PriceContainer: PriceContainer
    }
  }) : _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage." + normalKey,
    options: {
      currencyCode: activeCurrencyCode,
      price: monthlyCalculatedPrice,
      annualPrice: annualCalculatedPrice,
      merchandiseId: merchandiseId
    },
    elements: {
      MicroCopy: MicroCopy,
      PriceContainer: FullPriceContainerBlock,
      PriceDisplay: _PriceDisplay.default,
      Bold: Bold
    }
  }), showPriceAsterisk && _react.default.createElement(StyledAsterisk, {
    use: "help"
  }, '*'));
};

HighlightedMerchPriceDisplay.propTypes = {
  pricingInfo: _propTypes.default.object.isRequired,
  activeCurrencyCode: _propTypes.default.string.isRequired,
  showDiscountedPricing: _propTypes.default.bool.isRequired,
  merchandiseId: _propTypes.default.number.isRequired,
  showPriceAsterisk: _propTypes.default.bool,
  availableTerms: _propTypes.default.object,
  activeTerm: _propTypes.default.oneOf(Object.values(Terms)).isRequired,
  textAlign: _propTypes.default.string
};

var mapStateToProps = function mapStateToProps(state, _ref3) {
  var merchandiseId = _ref3.merchandiseId,
      activeTerm = _ref3.activeTerm,
      _ref3$additionalUnitQ = _ref3.additionalUnitQuantity,
      additionalUnitQuantity = _ref3$additionalUnitQ === void 0 ? 0 : _ref3$additionalUnitQ;
  var availableTerms = (0, _ItemConfigsSelectors.availableTermsForMerchSelector)(state, merchandiseId);
  return {
    pricingInfo: (0, _PricingSelectors.getCalculatePriceAndItemConfigSelector)(state)({
      merchandiseId: merchandiseId,
      term: activeTerm,
      additionalUnitQuantity: additionalUnitQuantity
    }),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    showDiscountedPricing: (0, _PromotionSelectors.showDiscountedPricingSelector)(state, merchandiseId, (0, _itemConfigUtils.getApplicableTerm)(activeTerm, availableTerms)),
    availableTerms: availableTerms
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(HighlightedMerchPriceDisplay);

exports.default = _default;
module.exports = exports.default;